import { FormControl, OutlinedInput } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormControl = styled(FormControl)(() => ({}));

export const StyledOutlinedInput = styled(OutlinedInput)(
  ({ theme, value, size, startAdornment, endAdornment }) => ({
    color: theme.palette.custom.black[90],
    lineHeight: '100%',

    ...(size === 'medium' && {
      height: '52px',

      '&.MuiInputBase-root .MuiOutlinedInput-input': {
        padding: '14.5px 14px',
        borderTopRightRadius: '14px',
        borderBottomRightRadius: '14px',
        borderTopLeftRadius: '14px',
        borderBottomLeftRadius: '14px',

        ...(startAdornment && {
          borderTopLeftRadius: '0px',
          borderBottomLeftRadius: '0px',
          paddingLeft: '5px',
        }),

        ...(endAdornment && {
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
          paddingRight: '5px',
        }),
      },
    }),

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.custom.black[!value ? 10 : 90],
      borderRadius: '14px',
    },

    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.custom.black[30],
      opacity: 1,
    },

    '&:hover:not(.Mui-disabled)': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.black[30],
      },
    },

    '&.Mui-error': {
      color: theme.palette.error.main,

      '& .MuiInputBase-input::placeholder': {
        color: theme.palette.error.main,
      },
    },

    '&.Mui-disabled': {
      borderRadius: '14px',
      backgroundColor: theme.palette.custom.grey3,
      borderColor: theme.palette.custom.black[20],
    },
  })
);
